// extracted by mini-css-extract-plugin
export default {"icon":"KfsL6","link":"qagWI","sizeInfo":"ZPnS_"};